(function($) {

// save a cookie to determine where the user is coming from

// get the body class
var bodyClass = $('body').attr('class');
// pull out the primary class, the one that matters to us later
var primaryClass = "";
if (bodyClass) {	
	var stayType = $('.villa').data('stay');
	var name = $('h1').text();
	primaryClass = "villa--"+stayType+"--"+name;
}

if (primaryClass.includes("villa")) {
	// time to apply those cookies you've been saving
	var prevPage = readCookie('prevPage');
	var backBtn = $('.villa__back');
	var text = "";
	console.log('the prev page was '+prevPage);
	if (prevPage) {
		if (prevPage.includes('villa')) {
			text = " to "+prevPage.split('--')[2];
		} else {
			text = " to "+prevPage;		
		}
		backBtn.fadeIn().find('span').text('Back'+text);

		// if we are navigating Villa to Villa we need to save an array of where we came from
		var prevPageStack = readCookie('prevPageStack');
		if (prevPageStack) {
			console.log('the prevPageStack is: ',prevPageStack + ' // ' + prevPage);
			newCookie('prevPageStack',prevPageStack + ' // ' + prevPage,1);	
		} else {
			console.log('the prevPageStack is: ',prevPage);
			newCookie('prevPageStack',prevPage,1);	
		}
	}
} else {
	deleteCookie('prevPageStack');
}
console.log('setting prevPage to '+name);
newCookie('prevPage',name,1);

if ($('.villa').length) {
	// back button 
	function backLogic() {
		console.log('running back logic...');
		var prevPageStack = readCookie('prevPageStack');
		if (prevPageStack) {
			var splitStack = prevPageStack.split(' // ');
			if (splitStack.length>1) {
				var newBack = splitStack[splitStack.length-2];
				console.log('setting prevPage to '+newBack);
				newCookie('prevPage',newBack,1);
				splitStack.splice(-2,2);
				var newStack = splitStack.join(' // ');
				console.log('setting prevPageStack to '+newStack);
				newCookie('prevPageStack',newStack,1);
			}
		}
	}
	$('.villa__back').on('click',function(){
		backLogic();
		window.history.back();
	});
	// activate first villa tab
	$('.hv-tabs__switcher span').eq(0).trigger('click');
	// clicking on a villa gallery mini pic opens the gallery on that image
	$('.villa__gallery__mini > div').on('click',function(){
		// var index = $(this).parent().find('> div').index($(this));
		// openGallery(index);
		if ($(this).hasClass('threeD')) {
			openTour();
		} else {
			var index = $(this).attr('rand');
			openGallery(index);
		}
	});
	// switching between gallery and 3D tour
	$('.gallery-switcher label').on('click',function(){
		$(this).addClass('active').siblings().removeClass('active');
		if ($(this).text()=="Gallery") {
			$('.hv-gallery').show();
			$('.villa__gallery__modal__tour').hide();
		} else {
			$('.hv-gallery').hide();
			$('.villa__gallery__modal__tour').show();
		}
	});
	// clicking launch gallery opens the gallery on the first image
	$('.villa__banner__overlay__launch-gallery').on('click',function(){
		openGallery(0);
	});
	// clicking close on the modal closes the modal
	$('.villa__gallery__modal__close').on('click',function(){
		$('.villa__gallery__modal').fadeOut();
	});	
	// share modal
	$('.villa__intro__share').on('click',function(){
		$('.share-modal').fadeIn();
	});
	$('.villa .share-modal').on('click',function(e){
		if ($(e.target).hasClass('share-modal')) {
			$('.share-modal').fadeOut();
		}
	});
	$('.villa .share-modal__close').on('click',function(){
		$('.share-modal').fadeOut();	
	});
	$('.villa .share-modal__box__options span').on('click',function(){
		$(this).append('<b style="font-weight:normal;margin-left:10px;">Copied!</b>');
		$(this).find('b').fadeOut(800,function(){$(this).remove();});

	    var dummy = document.createElement('input'),
		    text = window.location.href;

		document.body.appendChild(dummy);
		dummy.value = text;
		dummy.select();
		document.execCommand('copy');
		document.body.removeChild(dummy);
	});	

	function openGallery(index) {
		$modal = $('.villa__gallery__modal'); 
		$modal.fadeIn();
		$modal.find('.gallery-switcher label').eq(0).trigger('click');
		$modal.find('.hv-gallery__thumbs__inner > div').eq(index).trigger('click');
	}

	function openTour() {
		$modal = $('.villa__gallery__modal'); 
		$modal.fadeIn();
		$modal.find('.gallery-switcher label').eq(1).trigger('click');
	}
}
})( jQuery );  

function newCookie(name,value,days) {
  if (days) {
    var date = new Date();
    date.setTime(date.getTime()+(days*24*60*60*1000));
    var expires = "; expires="+date.toGMTString(); }
  else var expires = "";
  document.cookie = name+"="+value+expires+"; path=/"; 
}
function readCookie(name) {
  var nameSG = name + "=";
  var ca = document.cookie.split(';');
  for(var i=0; i<ca.length; i++) {
  var c = ca[i];
  while (c.charAt(0)==' ') c = c.substring(1,c.length);
  if (c.indexOf(nameSG) == 0) return c.substring(nameSG.length,c.length); }
  return null; 
}
function deleteCookie(name) {
	document.cookie = name+"=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
}